// extracted by mini-css-extract-plugin
export var section = "_3g-1";
export var topNav = "_3g-0";